import React, {Component} from 'react';
import {CheckBox} from "../../../components/ui/CheckBox";
import {FontAwesomeIcon} from "../../../components/ui/FontAwesomeIcon";
import {Collapse} from "reactstrap";
import {IAvidCheckBox, IAvidCheckTracker} from '../interfaces';

interface ITeamSelectorProps {
  avidList: IAvidCheckTracker[]
  checkBoxes: IAvidCheckBox[]
  isCollapsed: boolean
  updateCollapseState: () => void
  updateChildrenCollapseState: (avid: string) => void
  toggleTeamCheckbox: (selectedAvid: string) => void;
}

interface ITeamSelectorState {
  plainCheckboxes?: IAvidCheckBox[]
}

class TeamSelector extends Component<ITeamSelectorProps, ITeamSelectorState> {
  state: ITeamSelectorState = {
    plainCheckboxes: []
  }


  renderAvid(avid: string, indent: number) {
    const plainCheckboxes = Object.assign(this.props.avidList);
    let currentCheckboxChildren = [];

    const currentCheckbox: IAvidCheckTracker = plainCheckboxes.find((cb) => cb.id == avid);

    if (currentCheckbox) {
      if (currentCheckbox && currentCheckbox.children && currentCheckbox.children.length > 0) {
        currentCheckboxChildren = currentCheckbox.children.reduce((acc, curr) => {
          return acc.concat(curr.id)
        }, []);
      } else currentCheckboxChildren = [];

      const padding = (indent == 0 ? 0 : indent);
      const paddingSet = `${padding}em`;

      if (currentCheckbox.state.selected) {
        return (
          <Collapse isOpen key={`avid-checkbox-${avid}`}>
            <div>
              <div style={{paddingLeft: paddingSet}}>
                <div style={{display: 'inline-block'}}>
                  <CheckBox
                    isChecked={currentCheckbox.isChecked}
                    isEnabled={true}
                    label={currentCheckbox.text}
                    key={avid}
                    onChange={() => {
                      this.props.toggleTeamCheckbox(currentCheckbox.id);
                    }}
                  />
                </div>
                {(currentCheckbox.children && currentCheckbox.children.length > 0) &&
                <FontAwesomeIcon icon={(currentCheckbox.childrenCollapsed ? "plus" : 'minus')} size="sm"
                                 verticalAlign="middle" onClick={() => {
                  this.props.updateChildrenCollapseState(currentCheckbox.id)
                }}/>
                }
              </div>
              {
                currentCheckboxChildren.map((childCheckbox) => {
                  if (!currentCheckbox.childrenCollapsed) {
                    return this.renderAvid(childCheckbox, indent + 1);
                  }
                })
              }
            </div>
          </Collapse>
        );
      } else {
        return (
          currentCheckboxChildren.map((childCheckbox) => {
            return this.renderAvid(childCheckbox, indent + 0);
          })
        )
      }
    }
  }

  render() {
    return (
      <div>
        <h5 className='d-flex justify-content-between'>Team <i
          className={(this.props.isCollapsed ? "fas fas fa-angle-right" : "fas fa-angle-down")} onClick={() => {
          this.props.updateCollapseState()
        }}/></h5>
        <div className={(this.props.isCollapsed ? "collapse" : "collapse show")} style={{maxHeight: '260px', overflow: 'scroll'}}>
          {this.props.checkBoxes.map((input) => {
            return this.renderAvid(input.id, 0)
            }
          )}
        </div>
      </div>
    );
  }
}

export default TeamSelector;
